import React, { useEffect, useState } from 'react';
import Modal from '../../../Components/Modal';
import api from '../../../../system/client/src/services/api';
import './SizeFilter.css';

/* Region picker for the sidebar — the other way to say where, instead of a
 * postcode or place. Chips for what's chosen, and a modal of toggles, like
 * the business-type picker. Keeps traders in ANY chosen region. value is a
 * list of { key, name }, so the chips and the heading need no lookup. */
let cachedRegions = null;

const RegionFilter = ({ value = [], onChange }) => {
    const [open, setOpen] = useState(false);
    const [regions, setRegions] = useState(cachedRegions || []);

    useEffect(() => {
        if (!open || cachedRegions) return;
        api.get('traders/regions')
            .then((list) => {
                cachedRegions = list || [];
                setRegions(cachedRegions);
            })
            .catch(() => {});
    }, [open]);

    const chosen = new Set(value.map((r) => r.key));
    const toggle = (r) =>
        onChange(chosen.has(r.key) ? value.filter((x) => x.key !== r.key) : [...value, { key: r.key, name: r.name }]);

    return (
        <>
            {value.length > 0 && (
                <div className="tags" style={{ marginBottom: 6 }}>
                    {value.map((r) => (
                        <span key={r.key} className="tag-chip muted">
                            <span className="commodity-pill-text">{r.name}</span>
                            <button type="button" aria-label="Remove" onClick={() => toggle(r)}>
                                ×
                            </button>
                        </span>
                    ))}
                </div>
            )}
            <button
                type="button"
                className="btn btn-secondary btn-block commodity-picker-btn"
                onClick={() => setOpen(true)}
            >
                {value.length === 0 ? 'Choose regions' : `${value.length} selected — edit`}
            </button>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                title="Regions"
                width="560px"
                footer={
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <button type="button" className="btn btn-secondary" onClick={() => onChange([])}>
                            Clear
                        </button>
                        <button type="button" className="btn btn-primary" onClick={() => setOpen(false)}>
                            Done
                        </button>
                    </div>
                }
            >
                <p className="business-type-note">
                    Traders in any of the regions you pick. Picking a region clears the postcode or place.
                </p>
                <div className="size-filter business-type-grid" role="group" aria-label="Regions">
                    {regions.map((r) => (
                        <button
                            key={r.key}
                            type="button"
                            aria-pressed={chosen.has(r.key)}
                            className={chosen.has(r.key) ? 'on' : ''}
                            onClick={() => toggle(r)}
                        >
                            {r.name}
                            <span className="region-count">{r.traders.toLocaleString()}</span>
                        </button>
                    ))}
                    {regions.length === 0 && <span className="business-type-note">Loading…</span>}
                </div>
            </Modal>
        </>
    );
};

export default RegionFilter;
